import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type SponsoredAdFragmentFragment = {
	__typename?: 'SponsoredRecommendationAd';
	bidId: string;
	holdoutGroup: boolean;
	campaign: {
		__typename?: 'SponsoredRecommendationCampaign';
		hideRatings: boolean;
		promotionalImageUrl?: string | null;
		watchNowLabel?: string | null;
		externalTrackers: Array<{ __typename?: 'ExternalTracker'; type: Types.ExternalTrackerType; data: string }>;
		watchNowOffer: {
			__typename?: 'Offer';
			standardWebURL?: string | null;
			presentationType: Types.PresentationType;
			monetizationType: Types.MonetizationType;
			package: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				shortName: string;
				clearName: string;
				icon: string;
			};
		};
		node:
			| { __typename?: 'Article'; id: string }
			| { __typename?: 'Author'; id: string }
			| { __typename?: 'Bundle'; id: string }
			| { __typename?: 'Device'; id: string }
			| { __typename?: 'Episode'; id: string }
			| { __typename?: 'GenericTitleList'; id: string }
			| { __typename?: 'Genre'; id: string }
			| {
					__typename?: 'Movie';
					objectId: number;
					objectType: Types.ObjectType;
					id: string;
					content: {
						__typename?: 'MovieContent';
						fullPath: string;
						posterUrl?: string | null;
						title: string;
						originalReleaseYear?: number | null;
						isReleased: boolean;
						scoring: { __typename?: 'Scoring'; imdbScore?: number | null };
						externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
						backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					};
					offers: Array<{
						__typename?: 'Offer';
						monetizationType: Types.MonetizationType;
						presentationType: Types.PresentationType;
						id: string;
						package: { __typename?: 'Package'; id: string; packageId: number };
					}>;
					watchlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
			  }
			| { __typename?: 'MultiStepSportEvent'; id: string }
			| { __typename?: 'Offer'; id: string }
			| { __typename?: 'Package'; id: string }
			| { __typename?: 'Page'; id: string }
			| { __typename?: 'Person'; id: string }
			| { __typename?: 'Season'; id: string }
			| {
					__typename?: 'Show';
					objectId: number;
					objectType: Types.ObjectType;
					id: string;
					content: {
						__typename?: 'ShowContent';
						fullPath: string;
						posterUrl?: string | null;
						title: string;
						originalReleaseYear?: number | null;
						isReleased: boolean;
						scoring: { __typename?: 'Scoring'; imdbScore?: number | null };
						externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
						backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					};
					offers: Array<{
						__typename?: 'Offer';
						monetizationType: Types.MonetizationType;
						presentationType: Types.PresentationType;
						id: string;
						package: { __typename?: 'Package'; id: string; packageId: number };
					}>;
					watchlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					seenState: { __typename?: 'ShowSeenState'; seenEpisodeCount: number };
			  }
			| { __typename?: 'SingleStepSportEvent'; id: string }
			| { __typename?: 'SportCompetitionV2'; id: string }
			| { __typename?: 'SportCompetitorV2'; id: string }
			| { __typename?: 'Url'; id: string };
	};
};

export const SponsoredAdFragmentFragmentDoc = gql`
	fragment SponsoredAdFragment on SponsoredRecommendationAd {
		bidId
		holdoutGroup
		campaign {
			externalTrackers {
				type
				data
			}
			hideRatings
			promotionalImageUrl
			watchNowLabel
			watchNowOffer {
				standardWebURL
				presentationType
				monetizationType
				package {
					id
					packageId
					shortName
					clearName
					icon
				}
			}
			node {
				id
				... on MovieOrShow {
					content(country: $country, language: $language) {
						fullPath
						posterUrl
						title
						originalReleaseYear
						scoring {
							imdbScore
						}
						externalIds {
							imdbId
						}
						backdrops(format: $format, profile: $backdropProfile) {
							backdropUrl
						}
						isReleased
					}
					objectId
					objectType
					offers(country: $country, platform: $platform) {
						monetizationType
						presentationType
						package {
							id
							packageId
						}
						id
					}
					watchlistEntry {
						createdAt
					}
				}
				... on Show {
					seenState(country: $country) {
						seenEpisodeCount
					}
				}
			}
		}
	}
`;
